import { setWasmUrl } from "@lottiefiles/dotlottie-react";
import dotlottieWasmUrl from "@lottiefiles/dotlottie-web/dist/dotlottie-player.wasm?url";

setWasmUrl(dotlottieWasmUrl);

import { ApolloProvider } from "@apollo/client/react";
import { Global, ThemeContext } from "@emotion/react";
import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import Modal from "react-modal";
import { Provider } from "react-redux";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import { ErrorPageBoundary } from "./common/error-handling/ErrorPageBoundary";
import { App, AppLoading } from "./common/home/components/App";
import { ServerDownBoundary } from "./common/home/components/ServerDownBoundary";
import { initAppInsight } from "./common/tracking/appInsight";
import { enablePrintScrollOffsetFix } from "./enablePrintScrollOffsetFix";
import { globalStyles } from "./globalStyles";
import { initializeAnalyticsAfterAuth } from "./InitializeAnalyticsAfterAuth";
import { client, setErrorCallback } from "./services/apollo/apollo";
import { commonBeforeUnload } from "./services/common/commonActions";
import { persistor, store } from "./store/configureStore";
import { browserHistory } from "./store/utils/history";
import { defaultTheme } from "./themes/defaultTheme";
import { AuthProvider } from "./use-cases/auth/AuthContext";
import { getAuth, handleAuthOnLoad } from "./use-cases/auth/getAuthParams";

initAppInsight();
enablePrintScrollOffsetFix();

window.addEventListener("beforeunload", () => {
  store.dispatch(commonBeforeUnload());
});

Modal.setAppElement("#root");

setErrorCallback(store.dispatch);

const auth = getAuth(store, persistor);

handleAuthOnLoad(auth).then(initializeAnalyticsAfterAuth).catch(console.error);

createRoot(document.getElementById("root")!).render(
  <>
    <Global styles={globalStyles} />
    <Provider store={store}>
      <ApolloProvider client={client}>
        {/* @ts-expect-error https://github.com/remix-run/react-router/issues/9630 */}
        <HistoryRouter history={browserHistory}>
          <ThemeContext.Provider value={defaultTheme}>
            <ServerDownBoundary>
              <ErrorPageBoundary>
                <AuthProvider value={auth}>
                  <Suspense fallback={<AppLoading />}>
                    <App />
                  </Suspense>
                </AuthProvider>
              </ErrorPageBoundary>
            </ServerDownBoundary>
          </ThemeContext.Provider>
        </HistoryRouter>
      </ApolloProvider>
    </Provider>
  </>,
);
